import { Palette } from "@phosphor-icons/react";
import { money } from "@/lib/format";

// Staff banner: the customer picked a color from the emailed comparison.
export const ColourChoiceBanner = ({ choices = [], onApply, onDismiss, busy }) => {
  const open = choices.filter((c) => !c.acked_at);
  if (!open.length) return null;
  return (
    <div className="space-y-2" data-testid="colour-choice-banner">
      {open.map((c) => {
        const d = Number(c.delta || 0);
        return (
          <div
            key={c.area_id}
            data-testid={`colour-choice-${c.area_id}`}
            className="flex flex-wrap items-center gap-3 rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-3 py-2 text-xs text-emerald-100"
          >
            <Palette size={16} weight="bold" className="text-emerald-300" />
            <span>
              Customer picked <strong>{c.slab_color}</strong> for {c.area_name}
              {c.name ? ` (${c.name})` : ""} · {String(c.at || "").slice(0, 10)}
              {c.current
                ? " — keeps the quoted color"
                : ` — ${d > 0 ? "+" : "−"}${money(Math.abs(d))} on the quote`}
            </span>
            <span className="ml-auto flex items-center gap-2">
              {!c.current && (
                <button
                  type="button"
                  data-testid={`colour-choice-apply-${c.area_id}`}
                  disabled={busy}
                  onClick={() => onApply(c)}
                  className="rounded-full bg-emerald-400 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-emerald-950 transition-colors duration-150 hover:bg-emerald-300"
                >
                  Apply to quote
                </button>
              )}
              <button
                type="button"
                data-testid={`colour-choice-dismiss-${c.area_id}`}
                disabled={busy}
                onClick={() => onDismiss(c)}
                className="rounded-full border border-emerald-400/40 px-3 py-1 text-[10px] font-bold uppercase tracking-widest transition-colors duration-150 hover:bg-emerald-500/20"
              >
                {c.current ? "Got it" : "Dismiss"}
              </button>
            </span>
          </div>
        );
      })}
    </div>
  );
};
